import BulkReassign from '../contact-transfer/BulkReassign';
import React from 'react';
import { Button } from 'react-bootstrap';
import { Calendar, Book } from 'react-bootstrap-icons';
import { Link } from 'react-router-dom';
import BookAppointmentButton from '../store-calendar/BookAppointmentButton';
import { calendarLink } from '../store-calendar/bookingNavigation';
import './CRMQuickActions.css';

export default function CRMQuickActions({ preferredStoreId }) {
  const storeId = preferredStoreId && preferredStoreId !== 'all' ? preferredStoreId : '';
  return <nav className="crm-quick-actions" aria-label="CRM quick actions">
    <BookAppointmentButton preferredStoreId={storeId} />
    <BulkReassign preferredStoreId={storeId} />
    <div className="crm-resource-links">
      <Button as={Link} to={calendarLink(storeId)} target="_blank" rel="noopener noreferrer" variant="outline-primary" title="Store Calendar (opens in a new tab)">
        <Calendar aria-hidden="true" className="mr-1" /> Store Calendar
      </Button>
      <Button as={Link} to="/training-resources" target="_blank" rel="noopener noreferrer" variant="outline-primary" title="Training & Resources (opens in a new tab)">
        <Book aria-hidden="true" className="mr-1" /> Training &amp; Resources
      </Button>
    </div>
  </nav>;
}
